export enum EventFields {
  id = "id",
  cta = "cta",
  name = "name",
  registrationType = "registrationType",
  companyName = "companyName",
  locationName = "locationName",
  address = "address",
  address2 = "address2",
  zipCode = "zipCode",
  city = "city",
  country = "country",
  guestsTotal = "guestsTotal",
  guestsAccepted = "guestsAccepted",
  guestsDeclined = "guestsDeclined",
  guestsContacted = "guestsContacted",
  guestsWaitlist = "guestsWaitlist",
  guestsCheckedIn = "guestsCheckedIn",
  guestsUncontacted = "guestsUncontacted",
  start = "start",
  end = "end",
  timeZone = "timeZone",
  createdAt = "createdAt",
}
